<template>
  <v-dialog :key="data.dialogadress" v-model="data.dialogadress" width="900">
    <template v-slot:activator="{ on, attrs }">
      <v-card class="py-4" elevation="0" v-bind="attrs" v-on="on">
        <v-row>
          <v-col cols="1"
            ><v-icon color="secondary">fal fa-map-marker-alt</v-icon>
          </v-col>
          <v-col cols="9">{{ data.adres1 }} <br/> {{ data.adres2 }}<br/>  {{ data.postcode }}  {{ data.location_state }}  <br/> {{ data.country }}  </v-col>
          <v-col cols="1" class="text-right">
           <v-icon color="dark">fal fa-pencil</v-icon>
          </v-col>
        </v-row>
      </v-card>
    </template>

    <v-card elevation="0" class="rounded-lg pa-5">
      <v-html class="overline">Adres wijzigen</v-html>
      <v-spacer class="py-4"></v-spacer>
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="data.adres1"
            label="Adres"
            outlined
          ></v-text-field>
        </v-col>

         <v-col cols="12" sm="6">
          <v-text-field
            v-model="data.adres2"
            label="Adres 2"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="data.postcode"
            label="Postcode"
            outlined
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
          <v-text-field
            v-model="data.location_state"
            label="Plaats"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="data.country"
            label="Land"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="ml-auto text-right">
          <v-btn
            color="default"
            right
            to="/my-details"
            class="mr-3"
            elevation="0"
          >
            Annuleren
          </v-btn>
          <v-btn color="secondary" right @click="submit" elevation="0">
            Opslaan
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
   props: {
    data: Array,
  },
};
</script>

